import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  height: 100%;
  overflow: hidden;
  padding: 16px 0 16px 16px;

  > :last-child {
    margin-top: auto;
    padding-top: 20px;
  }
`

export const ButtonsWrapper = styled.div<{ isUpdate?: boolean }>`
  display: flex;
  gap: 12px;
  padding-right: 16px;

  ${({ isUpdate }) =>
    !isUpdate &&
    css`
      > div:last-child {
        margin-left: auto;
      }
    `}
`
